const laxEls = qsa(".lax")
const measurements = new Map()

const measure = throttle(() => {
  laxEls.forEach((el) => {
    const bbox = el.getBoundingClientRect()
    measurements.set(el, {
      bbox,
      docTop: bbox.top + window.scrollY,
    })
  })
}, 500)

const ro = new ResizeObserver(measure)
ro.observe(document.body)
const io = new IntersectionObserver((entries) => {
  const shouldMeasure =
    entries.filter((entry) => entry.isIntersecting).length > 0
  if (shouldMeasure) {
    requestAnimationFrame(measure)
  }
})
laxEls.forEach((el) => {
  io.observe(el)
  el.style.setProperty("--lax", 0)
})

function handleScroll(evt) {
  if(!evt) return
  const { scrollPos, windowHeight } = evt

  laxEls.forEach((el, i) => {
    let multiplier = parseFloat(el.getAttribute('data-lax-multiplier') || 1)
    if (measurements.size < 1) measure()
    const { bbox, docTop } = measurements.get(el)
    const start = docTop - windowHeight
    const end = docTop + bbox.height
    let pixelProgress = clamp(scrollPos - start, 0, end - start)
    let progress = clamp((pixelProgress / (end - start)) * multiplier, 0, 1)

    if (scrollPos > start && scrollPos < end) {
      requestAnimationFrame(() => {
        el.style.setProperty("--lax", progress.toFixed(3))
      })
    }
    requestAnimationFrame(() => {
      if (!el.classList.contains("lax-animating")) {
        el.classList.add("lax-animating")
      }
    })
  })
}

addScrollListener(handleScroll)
